<template>
  <li class="card --course">
    <img :src="image" alt="" class="card__image" />
    <div class="card__content">
      <h3>{{ content.title }}</h3>
      <LangRouterLink :to="{ name: 'course', params: { courseSlug: slug } }" class="button --card">
        {{ buttonLabel }}
      </LangRouterLink>
    </div>
  </li>
</template>

<script>
import image from '@/assets/images/course-icon.svg'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import { slugify } from '@/helpers/slugify.js'

export default {
  name: 'CourseCard',
  setup: () => ({
    image,
  }),
  components: { LangRouterLink },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    buttonLabel() {
      return this.$beet.isReady ? this.$beet.options.general.course.do : ''
    },
    slug() {
      return slugify(this.content.title)
    },
  },
}
</script>
